import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { useChosenLevel } from '../../hooks/useChosenLevel.js';

export const useFlightVersionListApi = () => {
  const { id: mediaDataId } = useChosenLevel();

  return useQuery({
    ...MediaPlan.getFlightVersionList({
      urlParams: { mediaDataId: mediaDataId ?? '' },
    }),

    enabled: !!mediaDataId,
    refetchOnWindowFocus: false,
    select: (data) => data?.data?.items,
  });
};
